import Image from '@/routing/Image'
import { ThemeToggle } from '@/components/auth/ThemeToggle'

export function AuthPreviewPanel() {
  return (
    <div className="absolute inset-8 overflow-hidden rounded-[20px]" style={{ background: 'radial-gradient(120% 80% at 50% -5%, #5ac87e 0%, #1e6b47 30%, #081919 70%)' }}>
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      <div className="absolute inset-0 flex items-center">
        <img
          src="/auth-preview.png"
          alt=""
          aria-hidden
          className="ml-[8%] w-full h-auto shrink-0"
        />
      </div>
    </div>
  )
}
